interface PencomDropdownProps {
  id: string;
  label: string;
  placeholder?: string;
  options: { id: string; label: string }[];
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  helperText?: string;
  disabled?: boolean;
  bg?: string;
}

const PencomDropdown = ({
  id,
  label,
  options,
  value,
  onChange,
  helperText,
  disabled,
  placeholder,
  bg,
}: PencomDropdownProps) => {
  const hasValue = value && value !== "";

  return (
    <div className="flex flex-col gap-y-2">
      <label
        htmlFor={id}
        className="font-clash-display text-medium-dark-grey text-md font-semibold"
      >
        {label}
      </label>
      <div className={`relative bg-${bg}`}>
        <select
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className="w-full items-start px-4 pr-10 font-regular text-xs font-clash-display text-medium-dark-grey py-3 border border-stroke rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-button focus:border-transparent appearance-none disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          {placeholder && (
            <option value="" disabled={!!hasValue}>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <img
            src="/assets/icons/dropdown-arrow.svg"
            alt="dropdown arrow"
            className="w-4 h-4"
          />
        </div>
      </div>
      {helperText && <p className="text-red-500 text-md mt-1 font-clash-display">{helperText}</p>}
    </div>
  );
};

export default PencomDropdown;
